import EngineControlCenters from "../classes/EngineControlCenter"

export const engineControlCenters = [
  new EngineControlCenters({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new EngineControlCenters({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new EngineControlCenters({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
